<template>
  <div>
    <wc-data-box title='Line Items' titleIcon='mdi-view-headline' titleIconColor='purple'
      :showAdd='!invoice.archived && !invoice.is_uncollectible' :loading='isLoading || isSavingLine'
      @add='addBlankLine'>
      <v-simple-table dense>
        <thead>
          <tr class='overline'>
            <th class='text-left'>Description</th>
            <th width='200'>Account</th>
            <th class='text-right' width='150'></th>
            <th class='text-right' width='75'>Qty</th>
            <th class='text-right' width='100'>Price</th>
            <th class='text-right' width='100'>Subtotal</th>
            <th class='text-right' width='100'>Tax</th>
            <th width='120'></th>
          </tr>
        </thead>
        <tbody>
          <invoice-line :disableEdit='invoice.archived || invoice.is_uncollectible' v-for='(line, index) in lines'
            :key='index' :line='line' :disableSortUp='upIsDisabled(index)' :disableSortDown='downIsDisabled(index)'
            :revenue_accounts='revenue_accounts' @push_line='push_line' @sortUp='sortUp(line, index)'
            @sortDown='sortDown(line, index)' @updateLine='updateLine' @deleteLine='confirmDelete'
            @cancelEdit='cancelEdit'></invoice-line>
        </tbody>
      </v-simple-table>
    </wc-data-box>
    <wc-dialog :showDialog='showConfirmDelete' title='Are you sure?' icon='mdi-alert' iconColor='error'
      @cancel='showConfirmDelete = false' width='350' saveText='Yes, Delete' saveColor='error' @save='deleteLine'>
      <!-- use callback from line -->
      <br>
      Are you sure you want to delete this line?<br>
      <br>
      <strong>{{ line.description }}</strong>
    </wc-dialog>
  </div>
</template>

<script>
import InvoiceLine from './InvoiceLine';
import assetsAPI from '@/modules/assets/api/inventory';
import accountingAPI from '@/api/accounting';

export default {
  name: 'invoice-lines',
  props: {
    invoice: {
      required: true
    },
    lines: {
      required: true
    },
    isSavingLine: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    showDialog: false,
    showConfirmDelete: false,
    inventory: [],
    revenue_accounts: [],
    line: {},
    line_to_delete: []
  }),
  created() {
    this.getData();
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.inventory = await assetsAPI.getInventoryForDivision(this.invoice.division);
      this.revenue_accounts = await accountingAPI.getRevenuePickerAccounts();
      this.isLoading = false;
    },
    addBlankLine() {
      this.lines.push({
        invoice: this.invoice.id,
        description: '',
        qty: '1',
        price: '0.00',
        has_gst: true,
        is_warranty: false,
        position: this.lines.length - 1
      });
      this.showDialog = true;
    },
    cancelAddBlankLine() {
      this.editMode = false;
      this.showDialog = false;
    },
    saveLine(line) {
      this.$emit('saveLine', line);
      this.showDialog = false;
    },
    sortUp(line, index) {
      this.$emit('sortUp', line, index);
    },
    sortDown(line, index) {
      this.$emit('sortDown', line, index);
    },
    confirmDelete(line) {
      this.line_to_delete = line;
      this.showConfirmDelete = true;
    },
    cancelEdit(invoice_line_item) {
      this.lines.map(line => {
        if (line.id === invoice_line_item.id) {
          const index = this.lines.indexOf(line);
          this.lines.splice(index, 1, invoice_line_item);
        }
      });
    },
    async deleteLine() {
      this.isLoading = true;
      const difference = -(this.line_to_delete.subtotal + this.line_to_delete.tax);
      this.$emit('updateTotals', difference);
      if (this.line_to_delete.id !== null && this.line_to_delete.id !== undefined) {
        await accountingAPI.deleteInvoiceLineItem(this.line_to_delete.id);
      }
      this.showConfirmDelete = false;

      this.lines.map(item => {
        if (item.id === this.line_to_delete.id) {
          const index = this.lines.indexOf(item);
          this.lines.splice(index, 1);
        }
      });
      this.line_to_delete = {};
      this.isLoading = false;
    },
    push_line(temp_invoice_line_item, invoice_line_item) {
      const subtotal = temp_invoice_line_item.qty * temp_invoice_line_item.price;
      const gst = temp_invoice_line_item.has_gst ? subtotal * this.$store.state.misc.settings.tax_rate_perc : 0;
      const difference = subtotal + gst;
      this.$emit('updateTotals', difference);
      const old_lines = [...this.lines];

      old_lines.map(item => {
        if (item === temp_invoice_line_item) {
          const index = old_lines.indexOf(item);
          old_lines.splice(index, 1, invoice_line_item);
        }
      });

      const ordering = [4115, 4120, 4125, 4110, 0];

      const new_lines = [];

      for(let i = 0; i < ordering.length; i++){
        old_lines.map(item => {
          if(item?.account_obj?.number === ordering[i]){
            new_lines.push(item);
          }

          if(
            ordering[i] === 0 &&
            item?.account_obj?.number !== 4115 &&
            item?.account_obj?.number !== 4120 &&
            item?.account_obj?.number !== 4125 &&
            item?.account_obj?.number !== 4110
          ){
            new_lines.push(item);
          }
        });
      }

    this.$emit('updateLines', new_lines);
    },
    updateLine(old_line, new_line) {
      let old_total = 0;
      let new_total = 0;

      if (!old_line.is_warranty) {
        const old_subtotal = old_line.qty * old_line.price;
        const old_gst = old_line.has_gst ? old_subtotal * this.$store.state.misc.settings.tax_rate_perc : 0;
        old_total = old_subtotal + old_gst;
      }

      if (!new_line.is_warranty) {
        const new_subtotal = new_line.qty * new_line.price;
        const gst = new_line.has_gst ? new_subtotal * this.$store.state.misc.settings.tax_rate_perc : 0;
        new_total = new_subtotal + gst;
      }

      const difference = new_total - old_total;
      this.lines.map(item => {
        if (item.id === old_line.id) {
          const index = this.lines.indexOf(item);
          this.lines.splice(index, 1, new_line);
        }
      });
      this.$emit('updateTotals', difference);
    },
    upIsDisabled(index) {
      return index === 0;
    },
    downIsDisabled(index) {
      return index === this.lines.length - 1;
    }
  },
  components: {
    'invoice-line': InvoiceLine
  }
}
</script>
